"use client";
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { TinyColor } from '@ctrl/tinycolor';
import * as React from 'react';
import { placeholder } from './styles.js';
import { usePrevMounted } from '../utils/hooks/usePrevMounted.web.js';
import { useTheme } from '../utils/theming/useTheme.js';

var _excluded = ["color", "pulseColor", "delay", "height", "width", "fadeIn"];
/**
 * Placeholders guide users to understanding a page's structure while data is being loaded
 */
var Placeholder = function Placeholder(_ref) {
  var colorProp = _ref.color,
    pulseColor = _ref.pulseColor,
    _ref$delay = _ref.delay,
    delay = _ref$delay === undefined ? 0 : _ref$delay,
    _ref$height = _ref.height,
    height = _ref$height === undefined ? '100%' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === undefined ? '100%' : _ref$width,
    _ref$fadeIn = _ref.fadeIn,
    fadeIn = _ref$fadeIn === undefined ? 500 : _ref$fadeIn,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePrevMounted = usePrevMounted(),
    _usePrevMounted2 = _slicedToArray(_usePrevMounted, 1),
    prevMounted = _usePrevMounted2[0];
  var theme = useTheme();
  var color = colorProp || theme.placeholder.web.color;
  return /*#__PURE__*/React.createElement(placeholder, _extends({
    "data-testid": "elemental-Placeholder",
    $color: color,
    $pulseColor: pulseColor ? pulseColor : new TinyColor(color).darken(5).toRgbString(),
    $delay: delay,
    height: height,
    width: width,
    $fadeIn: fadeIn,
    $mounted: prevMounted
  }, props));
};

export { Placeholder };
